import { render } from "./InteraccionMed.vue?vue&type=template&id=f7d24808&scoped=true"
import script from "./InteraccionMed.vue?vue&type=script&lang=js"
export * from "./InteraccionMed.vue?vue&type=script&lang=js"

import "@/assets/css/listaRegistros.css?vue&type=style&index=0&id=f7d24808&scoped=true&lang=css"
import "./InteraccionMed.vue?vue&type=style&index=1&id=f7d24808&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7d24808"]])

export default __exports__